export function IsBridgeId(id: string): boolean {
	const pattern = /^P[0-9A-Fa-f]{6}$/g;
	return pattern.test(id);
}
